import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { ReactNode, useState } from "react";

interface Props {
  icon: ReactNode;
  title: string;
  description: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export const CollapsibleFaqTile = (props: Props) => {
  const { icon, title, description, defaultOpen = false, children } = props;
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="faq_tile" data-test-id={`faq-tile-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <button className="faq_tile_header" onClick={() => setOpen(!open)} aria-expanded={open}>
        <div className="faq_tile_header_icon">{icon}</div>
        <div className="faq_tile_header_text">
          <h3 className="faq_tile_title">{title}</h3>
          <p className="faq_tile_description">{description}</p>
        </div>
        <div className="faq_tile_header_toggle">{open ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
      </button>
      {open && (
        <>
          <div className="faq_tile_divider" />
          <div className="faq_tile_body">{children}</div>
        </>
      )}
    </div>
  );
};
